import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.85, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);
